<script>
import { SlickList } from "vue-slicksort";
import LocationCard from "./LocationCard";
import LocationChooser from "./LocationChooser";

export default {
  name: "LocationsList",
  components: {
    LocationCard,
    SlickList,
    LocationChooser,
  },
  methods: {
    sort(locations) {
      this.$store.commit("setLocations", locations);
    }
  },
};
</script>
<template>
  <div class="locations" ref="locs">
    <LocationChooser />
    <SlickList
      :value="$store.state.locations"
      @input="sort"
      :pressDelay="200"
      lockAxis="y"
      :helperClass="'sort'"
    >
      <LocationCard
        v-for="(loc, index) in $store.state.locations"
        :index="index"
        :key="index"
        :loc="loc"
        @click.native="$emit('goto', index)"
      />
    </SlickList>
  </div>
</template>
<style lang="scss">
.locations {
  height: 100%;
  overflow-y: scroll;
}
</style>